import axiosInstance from '../../../../../utils/axios';
import { MarginBoostDTO } from './models';
import { ApiError } from './errors';

const getMarginBoosts = async (userUuid: string): Promise<MarginBoostDTO[]> => {
  try {
    const response = await axiosInstance.get<MarginBoostDTO[]>(
      `/margin-boost/user/${userUuid}`,
    );
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.status === 500) {
      throw new ApiError(error.response.data.error);
    } else {
      throw new ApiError('An unexpected error occurred');
    }
  }
};

export default getMarginBoosts;
